import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const scrollToPricing = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    title: 'BONO 1 — MEGA KIT RETENCIÓN CLÍNICA (TDAH & TEA)',
    subtitle: 'Hoja de Ruta 30 días + Tareas en Casa + Evidencia de Progreso',
    description: 'El 40% de las familias de TDAH/TEA abandonan el tratamiento en los primeros 3 meses porque no saben qué hacer en casa. Este bono te da el sistema para que eso no pase con tus pacientes.',
    image: 'https://cdn.magicpatterns.com/uploads/jPUMNWdqvQ2UsmtJxoAche/heylloyd-image-1773506632291-removebg-preview.png',
    isTransparent: true,
    includes: ['Hoja de Ruta 30 días (imprimible, lista para entregar al dar el diagnóstico).', 'Contrato de Objetivos: 3 metas medibles para los primeros 30 días.', 'Plan de Tareas en Casa (4 semanas con casilleros diarios).', 'Tracker Semáforo de Progreso Semanal.', 'Reporte de Progreso 30 días (para entregar firmado en la consulta siguiente).', 'Mini-Brief para la Escuela (pedido de observación en 10 días).', 'Pack de 18 Scripts Cálidos y Profesionales para consulta y WhatsApp.']
  }, {
    title: 'BONO 2 — MEGA KIT SECRETARIA DIGITAL (TDAH & TEA)',
    subtitle: 'WhatsApp Ordenado, Familias Calmas y Consultorio sin Incendios',
    description: 'Tu WhatsApp no es una guardia 24/7. Este bono convierte tu comunicación digital en un sistema que filtra, ordena y protege tu tiempo sin perder la calidez.',
    image: 'https://cdn.magicpatterns.com/uploads/7SczT8VqF1FqkGArCqWphx/heylloyd-image-1773506815433-removebg-preview.png',
    isTransparent: true,
    includes: ['Pack de 70 Respuestas Rápidas para WhatsApp Business (copiar/pegar).', 'Árbol de Triage (1 página): cuándo responder, cuándo agendar, cuándo derivar a guardia.', 'Plantilla "1 Sola Captura" para recibir información clínica útil (sin audios).', '12 Mensajes de Gestión de Turnos (confirmación, cancelación, tardanza, no-show).', 'Mensajes fuera de horario (automáticos) + bienvenida para nuevos pacientes.', 'Respuestas organizadas por 7 carpetas: NUEVO / SEGUIMIENTO / ESCUELA / MEDICACIÓN / ESTUDIOS / ADMIN / URGENCIA.']
  }, {
    title: 'BONO 3 — MEGA PACK SEGUIMIENTO PREMIUM (TDAH & TEA)',
    subtitle: 'Carpeta de Progreso + Evidencia para la Escuela + Reporte Trimestral',
    description: 'Transformá cada seguimiento en prueba visible de avance. Una carpeta lista que ordena a la familia, alinea a la escuela y hace que tu valor profesional se note y se valore.',
    image: 'https://cdn.magicpatterns.com/uploads/tdoVKWjX9NidqWPS2bh3H6/heylloyd-image-1773506974237-removebg-preview.png',
    isTransparent: true,
    includes: ['Carátula "Carpeta de Progreso" (para armar un folder físico profesional del paciente).', 'Ficha "Línea Base Día 0" (métricas de inicio antes del primer mes).', 'Registro Semanal de Casa (4 semanas, formato semáforo + ejemplo).', 'Registro Semanal de Escuela (4 semanas, para que el docente complete).', 'Matriz "Casa vs Escuela" (cruce de patrones para decidir con evidencia).', 'Reporte Mensual para Escuela (tono colaborativo, listo para imprimir).', 'Reporte Trimestral de Progreso (2 páginas, firmado, premium).', 'Constancia de Seguimiento (para presentar donde se requiera).']
  }];
  return <section className="py-20 bg-[#0B1426] relative overflow-hidden" data-id="element-29">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-600/5 blur-[150px] rounded-full pointer-events-none" data-id="element-30"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-32">
          <div className="inline-flex items-center justify-center gap-2 bg-yellow-500/10 text-yellow-500 px-4 py-2 rounded-full border border-yellow-500/20 mb-6" data-id="element-33">
            <Gift className="w-5 h-5" data-id="element-34" />
            <span className="font-bold tracking-wider" data-id="element-35">
              BONOS PROFESIONALES
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-36">
            GRATIS HOY con tu Mega Kit Neuro-Pro
          </h2>
        </motion.div>

        <div className="space-y-12" data-id="element-37">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#111827] border border-blue-500/30 rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(37,99,235,0.08)] flex flex-col md:flex-row" data-id="element-38">
              <div className={`md:w-1/3 relative cursor-pointer group overflow-hidden flex items-center justify-center ${(bono as any).isTransparent ? 'p-6 bg-[#0B1426]' : ''}`} onClick={scrollToPricing} data-id="element-39">
                {!(bono as any).isTransparent && <div className="absolute inset-0 bg-gradient-to-t from-[#111827] to-transparent z-10 md:bg-gradient-to-r" data-id="element-40"></div>}
                <img src={bono.image} alt={bono.title} className={`group-hover:scale-105 transition-transform duration-700 ${(bono as any).isTransparent ? 'w-full max-h-72 object-contain drop-shadow-2xl' : 'w-full h-64 md:h-full object-cover'}`} data-id="element-41" />
                <div className="absolute top-4 left-4 z-20 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-42">
                  GRATIS HOY
                </div>
              </div>

              <div className="p-6 md:p-8 md:w-2/3 flex flex-col justify-center" data-id="element-43">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-44">
                  {bono.title}
                </h3>
                <h4 className="text-yellow-500 font-semibold mb-4" data-id="element-45">
                  {bono.subtitle}
                </h4>
                <p className="text-gray-300 mb-6" data-id="element-46">{bono.description}</p>

                <div className="mb-6" data-id="element-47">
                  <p className="font-semibold text-white mb-3" data-id="element-48">Incluye:</p>
                  <ul className="space-y-2" data-id="element-49">
                    {bono.includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-50">
                        <span className="text-yellow-500 mt-0.5 flex-shrink-0" data-id="element-51">
                          ✓
                        </span>
                        <span data-id="element-52">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <div className="mt-auto pt-4 border-t border-gray-800" data-id="element-53">
                  <p className="text-gray-400" data-id="element-54">
                    <span className="line-through" data-id="element-55">Valor: $25.000 ARS</span> —{' '}
                    <span className="text-yellow-500 font-bold" data-id="element-56">
                      Tuyo gratis hoy.
                    </span>
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}